module.exports = __webpack_public_path__ + "static/kill-decision-add81c2b33353ea78952d2f506fba42e.jpg";